import actionTypes from 'registration/actions/action-types';
import utils from 'utils/lsp-utils-service';
import * as api from 'registration/resources/registration.api';

export const validateOwnerDataRequest = () => ({
  type: actionTypes.VALIDATE_OWNER_DATA_REQUEST,
});

export const validateOwnerDataSuccess = (ownerData) => ({
  type: actionTypes.VALIDATE_OWNER_DATA_SUCCESS,
  ownerData,
});

export const validateOwnerDataFailure = () => ({
  type: actionTypes.VALIDATE_OWNER_DATA_FAILURE,
});

export const validateOwnerData = (form, retailerType) => async (dispatch, getState) => {
  try {
    const { registration } = getState();
    let { retailerId, salts } = registration.retailer;
    if (retailerType === 'PROSPECTIVE') {
      retailerId = null;
      salts = null;
    }

    const { emailAddress: email, firstName, lastName, userValidation = '' } = form;

    const hashedPins = userValidation !== '' ? utils.getHashes(userValidation, salts) : null;

    dispatch(validateOwnerDataRequest());

    const params = {
      retailerId,
      firstName,
      lastName,
      email,
      hashedPins,
      retailerType,
    };

    const ownerData = await api.validateOwnerData(params);

    dispatch(validateOwnerDataSuccess(ownerData));
  } catch (error) {
    console.error('VALIDATE_OWNER_DATA_FAILURE', error);
    dispatch(validateOwnerDataFailure());
  }
};

export const validateProspectiveData = (form) => async (dispatch) => {
  try {
    const { userValidation: pin, captchaToken } = form;
    dispatch(validateOwnerDataRequest());
    const ownerData = await api.validateProspectiveData(pin, captchaToken);
    dispatch(validateOwnerDataSuccess(ownerData));
  } catch (error) {
    console.error('VALIDATE_PROSPECTIVE_DATA_FAILURE', error);
    dispatch(validateOwnerDataFailure());
  }
};

export const fetchOwnerData = (form) => async (dispatch) => {
  try {
    const { userValidation: ownerUrlParams, captchaToken } = form;
    dispatch(validateOwnerDataRequest());
    const ownerData = await api.fetchOwnerData(ownerUrlParams, captchaToken);
    dispatch(validateOwnerDataSuccess(ownerData));
  } catch (error) {
    console.error('VALIDATE_OWNER_DATA_FAILURE', error);
    dispatch(validateOwnerDataFailure());
  }
};



// WEBPACK FOOTER //
// ./src/modules/registration/actions/validate-owner-data.actions.js